/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicUser } from '../models/PublicUser';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProfileVisitService {
    /**
     * Visit Profile
     * @param playerId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static visitProfileProfileVisitVisitProfilePlayerIdPost(
        playerId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/profile_visit/visit_profile/{player_id}',
            path: {
                'player_id': playerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Profile Visits
     * @param playerId
     * @param lastXDays
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getProfileVisitsProfileVisitVisitProfilePlayerIdGet(
        playerId: number,
        lastXDays?: (number | null),
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/profile_visit/visit_profile/{player_id}',
            path: {
                'player_id': playerId,
            },
            query: {
                'last_x_days': lastXDays,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Profile Visit History
     * @param playerId
     * @param limit
     * @param offset
     * @param lastXDays
     * @returns PublicUser Successful Response
     * @throws ApiError
     */
    public static getProfileVisitHistoryProfileVisitHistoryPlayerIdGet(
        playerId: number,
        limit: number,
        offset: number,
        lastXDays?: (number | null),
    ): CancelablePromise<Array<PublicUser>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/profile_visit/history/{player_id}',
            path: {
                'player_id': playerId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'last_x_days': lastXDays,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
